module.exports = __webpack_public_path__ + "img/iv-ezust-arany-melegfoliazasa-thumb.2a8736df.jpg";